<template>
	<div>
		<el-button type="text" @click="dialogTableVisible = true">Xem chi tiết</el-button>
		<LinkInstruct v-if="isHeadOffice" :link="link"></LinkInstruct>
		<el-dialog :title="takeTitle" :visible.sync="dialogTableVisible">
			<gdkv-detail v-if="category === CATEGORY_THU_NHAP_RSM" :details="details"></gdkv-detail>
			<BackOfficeDetail v-else-if="isHeadOffice" :details="details"></BackOfficeDetail>
			<div v-else>
				<punish :details="details" :category="category"></punish>
			</div>
		</el-dialog>
	</div>
</template>


<script>
import {DETAIL_GDKV, DETAIL_GDVP, DETAIL_TINH, DETAIL_TRUNG_TAM,CATEGORY_THU_NHAP_RSM,CATEGORY_THUE_TNCN} from "../../../core/config/payslipConfig";
import GdkvDetail from "./Details/GdkvDetail";
import Punish from "./Details/Punish";
import BackOfficeDetail from "./Details/BackOfficeDetail";
import LinkInstruct from "./Details/LinkInstruct";
import {payslip_type} from '@/core/config/payslipVersion/index';

export default {
	name: 'phieu-luong-detail-item',
	components: {GdkvDetail, Punish, BackOfficeDetail, LinkInstruct},
	props: {
        details: {
            type: Array,
            default: () => [],
        },
		category: {
			type: String,
			default: null,
		},
		payslipType: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			dialogTableVisible: false,
			DETAIL_GDKV: DETAIL_GDKV,
			DETAIL_GDVP: DETAIL_GDVP,
			DETAIL_TRUNG_TAM: DETAIL_TRUNG_TAM,
			DETAIL_TINH: DETAIL_TINH,
			CATEGORY_THU_NHAP_RSM : CATEGORY_THU_NHAP_RSM,
			CATEGORY_THUE_TNCN: CATEGORY_THUE_TNCN,
			link: "https://docs.google.com/spreadsheets/d/1aUCnmLkZ6akdeEqAAW98UUB1ew_e4TAzTeIo96WXZfI/edit?gid=0#gid=0"
		}
	},
	computed: {
		isHeadOffice() {
			return this.payslipType === "head_office" && this.category === CATEGORY_THUE_TNCN;
		},
		firstItemType() {
			if (this.details.length > 0) {
				return this.details[0].type;
			} else {
				return 'gdkv_chi_tiet';
			}
		},
		takeTitle() {
			return this.category === CATEGORY_THUE_TNCN ? 'Xem chi tiết: Thuế thu nhập cá nhân' : 'Xem chi tiết';
		}
	}
};
</script>
<style>
.pointer {
	cursor: pointer;
}
</style>
